// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDefaultState as getAuditPreparationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import {postAudit} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const saveAudit = () =>

    async (dispatch, getState) => {

        let auditSaved;

        auditSaved = false;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postAudit(getState().tcsm.prepareAudit.auditPreparation);

            successAlertBar(translate('AUDIT_SUBMITTED_SUCCESSFULLY'));

            dispatch({
                data: getAuditPreparationDefaultState(),
                type: actions.RESET_TCSM_PREPARE_AUDIT_AUDIT
            });

            auditSaved = true;

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

            if (auditSaved) {

                dispatch(routerActions.push('/tcsm/audits'));

            }

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/save-audit.js